<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2023-11-01 09:43:39
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2023-12-08 17:14:08
 * @FilePath: \minipro-manger\src\views\WeatherAlert\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE   
-->
<template>
  <div>
    <el-card class="box-card" style="height:850px">
      <div slot="header">
        <div class="headerCardBox">
          <div style="width:400px">
            类型选择：
            <el-select v-model="value" placeholder="请选择">
              <el-option label="油菜" value="010603"></el-option>
              <el-option label="冬小麦" value="010301"></el-option>
              <el-option label="一季稻" value="010004"></el-option>
            </el-select>
          </div>
        </div>
        <div class="seachBtn">
          <el-button type="primary" @click="TypeChange">查询</el-button>
        </div>
      </div>
      <div>
        <div class="adddBtnBox">
          <el-button type="primary" @click="add">添加</el-button>
        </div>
        <el-table :data="tableData" style="width: 100%" :border="true" height="600" stripe>
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column prop="cropName" label="作物名"></el-table-column>

          <el-table-column prop="name" label="发育期"></el-table-column>
          <el-table-column prop="cropRemarks" label="信息"></el-table-column>
          <el-table-column prop="code" label="编码"></el-table-column>
          <el-table-column prop="start_month" label="开始时间"></el-table-column>
          <el-table-column prop="end_month" label="结束时间"></el-table-column>

          <!-- <el-table-column prop="address" label="状态"></el-table-column> -->
          <el-table-column prop="address" label="操作" width="250">
            <template slot-scope="scope">
              <el-button size="mini" @click="edit(scope.row)">修改</el-button>
              <el-popconfirm title="这是一段内容确定删除吗？" @confirm="mydelete(scope.row.id)">
                <el-button size="mini" type="danger" slot="reference">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <el-pagination background layout="prev, pager, next" :total="1"></el-pagination> -->
    </el-card>
    <el-dialog title="信息修改" :visible.sync="dialogVisible" width="30%">
      <el-input placeholder="请输入内容" v-model="eidtData.code">
        <template slot="prepend">编码</template>
      </el-input>
      <el-input placeholder="请输入内容" v-model="eidtData.name" style="margin-top:10px">
        <template slot="prepend">发育期</template>
      </el-input>

      <div class="timeBoxIn" style="margin-top:10px">
        <div>开始时间:</div>
        <div>
          <el-date-picker
            v-model="eidtData.start_month"
            align="right"
            type="date"
            format="MM-dd"
            value-format="MM-dd"
            placeholder="选择日期"
          ></el-date-picker>
        </div>
      </div>
      <div class="timeBoxIn" style="margin-top:10px">
        <div>结束时间:</div>
        <div>
          <el-date-picker
            v-model="eidtData.end_month"
            align="right"
            type="date"
            format="MM-dd"
            value-format="MM-dd"
            placeholder="选择日期"
          ></el-date-picker>
        </div>
      </div>
      <el-input placeholder="请输入内容" v-model="eidtData.sorts" style="margin-top:10px">
        <template slot="prepend">序号</template>
      </el-input>
      <el-input placeholder="请输入内容" v-model="eidtData.remarks" style="margin-top:10px">
        <template slot="prepend">描述</template>
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitEdit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="信息新增" :visible.sync="addPopShow" width="30%">
      <el-input placeholder="请输入内容" v-model="addData.code">
        <template slot="prepend">编码</template>
      </el-input>
      <el-input placeholder="请输入内容" v-model="addData.name" style="margin-top:10px">
        <template slot="prepend">发育期</template>
      </el-input>

      <div class="timeBoxIn" style="margin-top:10px">
        <div>开始时间:</div>
        <div>
          <el-date-picker
            v-model="addData.start_month"
            align="right"
            type="date"
            format="MM-dd"
            value-format="MM-dd"
            placeholder="选择日期"
          ></el-date-picker>
        </div>
      </div>
      <div class="timeBoxIn" style="margin-top:10px">
        <div>结束时间:</div>
        <div>
          <el-date-picker
            v-model="addData.end_month"
            align="right"
            type="date"
            format="MM-dd"
            value-format="MM-dd"
            placeholder="选择日期"
          ></el-date-picker>
        </div>
      </div>
      <el-input placeholder="请输入内容" v-model="addData.sorts" style="margin-top:10px">
        <template slot="prepend">序号</template>
      </el-input>
      <el-input placeholder="请输入内容" v-model="addData.remarks" style="margin-top:10px">
        <template slot="prepend">描述</template>
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addPopShow = false">取 消</el-button>
        <el-button type="primary" @click="submitAdd">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  data() {
    return {
      textarea: "",
      input1: "",
      tableData: [],
      value: "010603",
      allData: [],
      dialogVisible: false,
      addPopShow: false,
      chooseData: {},
      eidtData: {},
      addData: {
        cropCode: "",
        code: "",
        name: "",
        startMonth: "",
        endMonth: "",
        sorts: "",
        remarks: "",
        id: ""
      }
    };
  },
  created() {
    this.getTableData();
  },
  methods: {
    mydelete(data) {
      this.axios({
        method: "post",
        url: "https://www.moodsci.com/chongzhou/crop/deleteCropGrowth",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: {
          id: data
        }
      }).then(res => {
        console.log(res.data);
        this.tableData = res.data;
        this.$message({
          message: "删除成功",
          type: "success"
        });
        this.addPopShow = false;
        this.getTableData();
      });
    },
    add() {
      this.addPopShow = true;
    },
    edit(e) {
      console.log(e);
      this.dialogVisible = true;
      this.eidtData = e;
    },
    submitAdd() {
      console.log(this.addData);
      this.axios({
        method: "post",
        url: "https://www.moodsci.com/chongzhou/crop/addCropGrowth",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: {
          cropCode: this.value,
          code: this.addData.code,
          name: this.addData.name,
          startMonth: this.addData.start_month,
          endMonth: this.addData.end_month,
          sorts: this.addData.sorts,
          remarks: this.addData.remarks
        }
      }).then(res => {
        console.log(res.data);
        this.tableData = res.data;
        this.$message({
          message: "添加成功",
          type: "success"
        });
        this.addPopShow = false;
        this.getTableData();
      });
    },
    submitEdit() {
      console.log({
        cropCode: this.eidtData.cropCode,
        code: this.eidtData.code,
        name: this.eidtData.name,
        startMonth: this.eidtData.start_month,
        endMonth: this.eidtData.end_month,
        sorts: this.eidtData.sorts,
        remarks: this.eidtData.remarks,
        id: this.eidtData.id
      });
      //   return;
      this.axios({
        method: "post",
        url: "https://www.moodsci.com/chongzhou/crop/updateCropGrowth",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: {
          cropCode: this.eidtData.cropCode,
          code: this.eidtData.code,
          name: this.eidtData.name,
          startMonth: this.eidtData.start_month,
          endMonth: this.eidtData.end_month,
          sorts: this.eidtData.sorts,
          remarks: this.eidtData.remarks,
          id: this.eidtData.id
        }
      }).then(res => {
        console.log(res.data);
        this.tableData = res.data;
        this.$message({
          message: "修改成功",
          type: "success"
        });
        this.dialogVisible = false;
        this.getTableData();
      });
    },
    TypeChange() {
      //   this.tableData = this.allData[this.value];
      this.getTableData();
    },
    getTableData() {
      this.axios({
        method: "post",
        url: "https://www.moodsci.com/chongzhou/crop/getCropGrowth",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: {
          cropCode: this.value
        }
      }).then(res => {
        console.log(res.data);
        this.tableData = res.data;
      });
    }
  }
};
</script>

<style>
.headerCardBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.seachBtn {
  display: flex;
  justify-content: end;
  margin-top: 15px;
}
.adddBtnBox {
  height: 50px;
  float: right;
}
.timeBoxIn {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>